import { useContext } from 'react';

import TownCaseChatContext from './TownCaseChatContext';

const useTownCaseChats = () => {
  const context = useContext(TownCaseChatContext);
  if (context === null) {
    throw new Error('useTownCaseChats must be used within a TownCaseChatProvider');
  }
  return context;
};

export default useTownCaseChats;
